export default "__VITE_ASSET__D6kJ85H0__"